// extracted by mini-css-extract-plugin
export default {"bg":"BKeosi","inlineContent":"JKQUTW","pageWrapper":"Hygh8Z","innerBg2":"In432A","innerBg":"Pl3Krf"};